<template>
    <img
        v-if="photoUrl"
        :src="photoUrl"
        :width="size"
        :height="size"
        class="competitor-avatar-photo clarity-mask"
        :style="{ '--avatar-border-width': borderWidth }"
        alt=""
    />
    <div
        v-else
        class="competitor-avatar-initials clarity-mask"
        :style="{
            width: size + 'px',
            height: size + 'px',
            backgroundColor: PLACEHOLDER_COLOR,
            fontSize: fontSize + 'px',
            '--avatar-border-width': borderWidth,
            borderRadius: '50%',
        }"
    >
        {{ initials }}
    </div>
</template>

<script setup lang="ts">
    import { computed } from "vue";

    const props = withDefaults(
        defineProps<{
            firstName: string;
            lastName: string;
            photoUrl: string | null;
            size?: number;
        }>(),
        { size: 32 },
    );

    const PLACEHOLDER_COLOR = "#546e7a";

    const initials = computed(() => {
        const f = props.firstName.trim()[0] ?? "";
        const l = props.lastName.trim()[0] ?? "";
        return (f + l).toUpperCase();
    });

    const fontSize = computed(() => Math.round(props.size * 0.38));
    const borderWidth = computed(() => (props.size >= 48 ? "2px" : "1px"));
</script>
